'use client'

import DocPage from './DocPage'

export default function Service({ vendor }: { vendor?: any }) {
  return (
    <DocPage
      vendor={vendor}
      pageKey="service"
      titleLead="Үйлчилгээний"
      titleAccent="нөхцөл"
      description="Энэхүү дэлгүүрийн платформыг ашиглах хэрэглэгч болон үйлчилгээ үзүүлэгчийн хооронд үүсэх харилцааг зохицуулна."
      htmlContent={vendor?.terms?.service}
      emptyMessage="Одоогоор үйлчилгээний нөхцөл нэмэгдээгүй байна."
    />
  )
}
